class SequenceEvaluation {
    constructor (params) {
        this.id = params?.id || null;
        this.name = params?.name || null;
        this.status = params?.status || null;
        this.employeeToNotify = params?.employeeToNotify || {
            id: null,
            name: null
        };
        this.assignedEmployees = params?.assignedEmployees || [];
        this.point = params?.point || {
            id: null,
            name: null
        };
        this.incidentType = params?.incidentType || {
            id: null,
            name: null
        };
        this.inspectionTemplate = params?.inspectionTemplate || {
            id: null,
            name: null
        };
        this.startDateTime = params?.startDateTime || null;
        this.endDateTime = params?.endDateTime || null;
        this.timeToNotifyBeforeSequence = params?.timeToNotifyBeforeSequence || null;
        this.repetitionScheme = params?.repetitionScheme || null;
        this.cycleFrequencyInDays = params?.cycleFrequencyInDays || null;
        this.repetitionDates = params?.repetitionDates || null;
        this.repetitionWeekdays = params?.repetitionWeekdays || null;
        this.routeSteps = params?.routeSteps || [];
        this.sequence = params?.sequence || {
            type: null,
            durationTime: null,
            repetitionPattern: null,
            repetitionCount: null,
            repetitionHours: [],
            steps: []
        };
    }

    formatDuration (time) {
        if (time) {
            return time.HH * 3600 + time.mm * 60;
        }
        return null;
    }

    timeToDuration (time) {
        if (time) {
            const [HH, mm] = time.split(':');
            return {
                HH,
                mm
            };
        }
        return null;
    }

    parseData (payload) {
        this.id = payload.id;
        this.name = payload.track_name;
        this.status = payload.status;
        this.employeeToNotify = {
            id: payload.employee_to_notify?.id.toString() || null,
            name: payload.employee_to_notify?.full_name || null
        };
        this.assignedEmployees = payload.assigned_employees.map(employee => ({
            value: employee.id.toString() || null,
            text: employee.full_name
        }));
        this.point = {
            id: payload.point_id?.toString() || null,
            name: payload.point_name
        };
        this.incidentType = {
            id: payload.incident_type_id?.toString() || null,
            name: payload.incident_type_name
        };
        this.inspectionTemplate = {
            id: payload.inspection_template?.toString() || null,
            name: payload.inspection_template_name
        };
        this.startDateTime = payload.start_datetime;
        this.endDateTime = payload.end_datetime;
        this.timeToNotifyBeforeSequence = this.timeToDuration(payload.time_to_notify_before_sequence);
        this.notifyByEmail = payload?.notify_by_email;
        this.cycleFrequencyInDays = payload.cycle_frequency_in_days;
        this.repetitionScheme = payload.repetition_scheme;
        this.repetitionDates = payload.repetition_dates;
        this.repetitionWeekdays = payload.repetition_weekdays;
        this.routeSteps = payload.route_steps.map(step => {
            return {
                evaluated: step.evaluated,
                evaluation_date: step.evaluation_date,
                id: step.id,
                name: step.name,
                nr: step.nr,
                passed: step.passed,
                scanTime: step.scan_time,
                status: step.status,
                order: step.step
            };
        });
        this.sequence = {
            type: payload.sequence_details.type,
            durationTime: this.timeToDuration(payload.sequence_details.duration_time),
            repetitionPattern: payload.sequence_details.repetition_pattern,
            repetitionCount: payload.sequence_details.repetition_count,
            repetitionHours: payload.sequence_details.repetition_hours,
            steps: [],
            activeSteps: payload.sequence_details.steps.map(step => {
                return {
                    order: step.order,
                    sequence: step.sequence,
                    timeSinceSequenceStart: this.timeToDuration(step.time_since_sequence_start),
                    tolerance: this.timeToDuration(step.tolerance),
                    verificationWay: step.verification_way,
                    template: {
                        id: step.template_id?.toString() || null,
                        name: step.template_name
                    },
                    point: {
                        id: step.point_id ? `${step.point_id}_point` : null,
                        name: step.point_name,
                        clientId: step.client_id?.toString() || null,
                        locationId: step.location_id ? `${step.location_id}_site` : null
                    },
                    employee: {
                        id: step.employee_id?.toString() || null,
                        name: step.employee_name,
                        isItem: step.employee_is_item || false
                    },
                    parent_id: step.order === 0 ? null : step.order,
                    value: step.template_id || step.verification_way,
                    name: step.employee_name || step.point_name
                };
            })
        };
    }
}

export default SequenceEvaluation;
